import { jwtDecode } from "jwt-decode";

const roleMap = { 1: "admin", 2: "admin", 3: "user", 37: "guest" };

export function logout() {
  ["token", "name", "role"].forEach((k) => localStorage.removeItem(k));
}

// role จาก token ใน localStorage — token เสีย/หมดอายุ = logout แล้วคืน "guest"
export function getRole() {
  const token = localStorage.getItem("token");
  if (!token) return "guest";
  try {
    const d = jwtDecode(token);
    if (d.exp && d.exp * 1000 < Date.now()) throw new Error("token expired");
    if (roleMap[d.role_id]) return roleMap[d.role_id];
    return ["admin", "user"].includes(d.role) ? d.role : "guest"; // backend สมัครใหม่ = "guest"
  } catch {
    logout();
    return "guest";
  }
}
